import { render, staticRenderFns } from "./MSalesbar.vue?vue&type=template&id=04ba430b&"
import script from "./MSalesbar.vue?vue&type=script&lang=js&"
export * from "./MSalesbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports